// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_dg-0";